import { render, staticRenderFns } from "./ScientificPart.vue?vue&type=template&id=1ec81929&"
import script from "./ScientificPart.vue?vue&type=script&lang=js&"
export * from "./ScientificPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports